var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "videoWrapper",
      staticClass: "video-wrapper",
      attrs: {
        tabindex: _vm.isBackgroundVideo ? -1 : 0,
        "aria-label": _vm.altText,
      },
      on: {
        mousedown: function ($event) {
          return _vm.clickOnVideo()
        },
        mouseup: _vm.togglePlay,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.handleSpaceKey($event)
        },
      },
    },
    [
      _vm.isBackgroundVideo
        ? _c(
            "video",
            {
              ref: "player",
              attrs: {
                autoplay: _vm.isBackgroundVideo && !_vm.isSitecore,
                muted: "",
                loop: _vm.isBackgroundVideo && !_vm.isSitecore,
                playsinline: _vm.isBackgroundVideo && !_vm.isSitecore,
                "webkit-playsinline": _vm.isBackgroundVideo && !_vm.isSitecore,
              },
              domProps: { muted: true },
              on: {
                play: function ($event) {
                  _vm.isPlaying = true
                },
                pause: function ($event) {
                  _vm.isPlaying = false
                },
                timeupdate: _vm.timeUpdate,
                loadedmetadata: _vm.metadataUpdate,
              },
            },
            [
              _c("source", {
                ref: "videoSource",
                attrs: { src: _vm.src, type: "video/mp4" },
              }),
              _vm._v(" "),
              _vm.captions
                ? _c("track", {
                    attrs: {
                      label: "CC",
                      srclang: _vm.lang,
                      kind: "captions",
                      src: _vm.src,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.descriptions
                ? _c("track", {
                    attrs: {
                      label: "Description",
                      srclang: _vm.lang,
                      kind: "descriptions",
                      src: _vm.src,
                    },
                  })
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.notSupportedMsg) + "\n  "),
            ]
          )
        : _c(
            "video",
            {
              ref: "player",
              on: {
                play: function ($event) {
                  _vm.isPlaying = true
                },
                pause: function ($event) {
                  _vm.isPlaying = false
                },
                timeupdate: _vm.timeUpdate,
                loadedmetadata: _vm.metadataUpdate,
              },
            },
            [
              _c("source", {
                ref: "videoSource",
                attrs: { src: _vm.src, type: "video/mp4" },
              }),
              _vm._v(" "),
              _vm.captions
                ? _c("track", {
                    attrs: {
                      label: "CC",
                      srclang: _vm.lang,
                      kind: "captions",
                      src: _vm.src,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.descriptions
                ? _c("track", {
                    attrs: {
                      label: "Description",
                      srclang: _vm.lang,
                      kind: "descriptions",
                      src: _vm.src,
                    },
                  })
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.notSupportedMsg) + "\n  "),
            ]
          ),
      _vm._v(" "),
      !_vm.isBackgroundVideo || _vm.isBackgroundVideo === 0
        ? _c("div", { staticClass: "ui" }, [
            _vm.showVideoPoster
              ? _c(
                  "div",
                  {
                    staticClass: "poster",
                    class: { "no-poster": _vm.noPosterImage },
                    style: [
                      { "background-image": "url(" + this.videoPoster + ")" },
                    ],
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "play-icon",
                        attrs: { type: "button", "aria-label": "Play" },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v(_vm._s(_vm.tc("videoPlayer.play"))),
                        ]),
                      ]
                    ),
                  ]
                )
              : !_vm.isBackgroundVideo || _vm.isBackgroundVideo === 0
              ? _c(
                  "div",
                  {
                    staticClass: "controls",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "buttons" }, [
                      _c("div", { staticClass: "left-section" }, [
                        _c("div", { staticClass: "btn play-pause" }, [
                          _c(
                            "button",
                            {
                              ref: "playPauseButton",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.isPlaying
                                  ? _vm.tc("videoPlayer.pause")
                                  : _vm.tc("videoPlayer.play"),
                              },
                              on: {
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.togglePlay({ isKeyboard: true })
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.togglePlay({ isKeyboard: true })
                                  },
                                ],
                              },
                            },
                            [
                              !_vm.isPlaying
                                ? _c("i", {
                                    staticClass: "fa fa-play",
                                    attrs: { "aria-hidden": "true" },
                                  })
                                : _c("i", {
                                    staticClass: "fa fa-pause",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "volume" },
                          [
                            _c(
                              "button",
                              {
                                attrs: {
                                  type: "button",
                                  "aria-label": _vm.volume
                                    ? _vm.tc("videoPlayer.mute")
                                    : _vm.tc("videoPlayer.unmute"),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.toggleVolume($event)
                                  },
                                },
                              },
                              [
                                _vm.volume
                                  ? _c("i", {
                                      staticClass: "fa fa-volume-up",
                                      attrs: { "aria-hidden": "true" },
                                    })
                                  : _c("i", {
                                      staticClass: "fa fa-volume-off",
                                      staticStyle: { "margin-right": "12px" },
                                      attrs: { "aria-hidden": "true" },
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("slider", {
                              ref: "volume",
                              class: { active: _vm.displayVolumeSlider },
                              attrs: {
                                "aria-label": _vm.tc("videoPlayer.volume"),
                                "slider-type": "volume",
                              },
                              on: {
                                focus: _vm.showVolumeSlider,
                                blur: _vm.hideVolumeSlider,
                              },
                              model: {
                                value: _vm.volume,
                                callback: function ($$v) {
                                  _vm.volume = $$v
                                },
                                expression: "volume",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "center-section" },
                        [
                          _c("slider", {
                            ref: "timeline",
                            staticClass: "timeline",
                            attrs: {
                              min: 0,
                              max: _vm.videoDuration,
                              "aria-label": _vm.tc("videoPlayer.progressBar"),
                            },
                            on: {
                              interact: function ($event) {
                                _vm.isSeeking = $event
                              },
                            },
                            model: {
                              value: _vm.currentTime,
                              callback: function ($$v) {
                                _vm.currentTime = $$v
                              },
                              expression: "currentTime",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "timestamp" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.timeRemaining) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "video-controls", attrs: { tabindex: "0" } },
            [
              _vm.isPlaying
                ? _c("div", { staticClass: "video-pause" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "25px",
                          height: "25px",
                          viewBox: "0 0 25 25",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c("title", [
                          _vm._v(_vm._s(_vm.tc("videoPlayer.pause"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "--Masthead",
                              stroke: "none",
                              "stroke-width": "1",
                              fill: "none",
                              "fill-rule": "evenodd",
                              opacity: "1",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "Masthead-Global-homepage-mobile-Copy",
                                  transform:
                                    "translate(-331.000000, -488.000000)",
                                  fill: "#FFFFFF",
                                  "fill-rule": "nonzero",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "02-Elements/Graphics/Icons/play",
                                      transform:
                                        "translate(331.000000, 488.000000)",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        id: "",
                                        d: "M12.0555268,24.1110536 C18.7152332,24.1110536 24.1110536,18.7152332 24.1110536,12.0555268 C24.1110536,5.39582047 18.7152332,0 12.0555268,0 C5.39582047,0 0,5.39582047 0,12.0555268 C0,18.7152332 5.39582047,24.1110536 12.0555268,24.1110536 Z M12.0555268,22.7221935 C6.16219348,22.7221935 1.38886015,17.9488601 1.38886015,12.0555268 C1.38886015,6.16219348 6.16219348,1.38886015 12.0555268,1.38886015 C17.9488601,1.38886015 22.7221935,6.16219348 22.7221935,12.0555268 C22.7221935,17.9488601 17.9488601,22.7221935 12.0555268,22.7221935 Z M9,6.22222222 L9.66666667,6.22222222 C10.2189514,6.22222222 10.6666667,6.66993747 10.6666667,7.22222222 L10.6666667,16.7777778 C10.6666667,17.3300625 10.2189514,17.7777778 9.66666667,17.7777778 L9,17.7777778 C8.44771525,17.7777778 8,17.3300625 8,16.7777778 L8,7.22222222 C8,6.66993747 8.44771525,6.22222222 9,6.22222222 Z M14.3333333,6.22222222 L15,6.22222222 C15.5522847,6.22222222 16,6.66993747 16,7.22222222 L16,16.7777778 C16,17.3300625 15.5522847,17.7777778 15,17.7777778 L14.3333333,17.7777778 C13.7810486,17.7777778 13.3333333,17.3300625 13.3333333,16.7777778 L13.3333333,7.22222222 C13.3333333,6.66993747 13.7810486,6.22222222 14.3333333,6.22222222 Z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isPlaying
                ? _c("div", { staticClass: "video-play" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "25px",
                          height: "26px",
                          viewBox: "0 0 25 26",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c("title", [
                          _vm._v(_vm._s(_vm.tc("videoPlayer.play"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "--Masthead",
                              stroke: "none",
                              "stroke-width": "1",
                              fill: "none",
                              "fill-rule": "evenodd",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "Masthead-Property-homepage",
                                  transform:
                                    "translate(-1396.000000, -583.000000)",
                                  fill: "#FFFFFF",
                                  "fill-rule": "nonzero",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "02-Elements/Graphics/Icons/play-Copy",
                                      transform:
                                        "translate(1396.437499, 583.937557)",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        id: "",
                                        d: "M12.0555268,24.1110536 C18.7152332,24.1110536 24.1110536,18.7152332 24.1110536,12.0555268 C24.1110536,5.39582047 18.7152332,0 12.0555268,0 C5.39582047,0 0,5.39582047 0,12.0555268 C0,18.7152332 5.39582047,24.1110536 12.0555268,24.1110536 Z M12.0555268,22.7221935 C6.16219348,22.7221935 1.38886015,17.9488601 1.38886015,12.0555268 C1.38886015,6.16219348 6.16219348,1.38886015 12.0555268,1.38886015 C17.9488601,1.38886015 22.7221935,6.16219348 22.7221935,12.0555268 C22.7221935,17.9488601 17.9488601,22.7221935 12.0555268,22.7221935 Z M10.0347332,17.6966078 L17.600879,13.138829 C18.3058811,12.7281953 18.3058811,11.6586878 17.600879,11.243515 L10.0347332,6.41497704 C9.35550807,6.01787245 8.50000093,6.52779335 8.50000093,7.36263403 L8.50000093,16.7489508 C8.50000093,17.5792965 9.35118393,18.0937124 10.0347332,17.6966078 Z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-section" }, [
      _c("div", { staticClass: "btn full-screen" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }